<template>
    <div id="app">
        <keep-alive>
            <!-- 如果当前打开页面的路由中 keepAlive: true （开启了缓存时） -->
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>

        <!--路由占位符-->
        <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
</template>
<script>
    export default {
        name: "app"
    }
</script>
<style>
</style>
